export default __webpack_public_path__ + "static/media/sohail.f480a12a.jpeg";